import { Component, memo } from 'react';
import _debounce from 'lodash/debounce';
import { setDisplayScales, getFontSizeFromDOM, getProbeDivElement, getSizeErrorCorrectionFactor, setDisplayScaleAutomatically } from '../../utils/scale';
class AutoFontResizer extends Component {
  constructor(props) {
    super(props);
    this.onBodyResize = () => {
      const {
        width
      } = document.body.getBoundingClientRect();
      setDisplayScaleAutomatically(width);
      const displayScale = getFontSizeFromDOM();
      window.pxToRemErrorRate = getSizeErrorCorrectionFactor(displayScale);
    };
    this.onBodyResizeDebounced = _debounce(this.onBodyResize, 500);
    this.componentDidMount = () => {
      if (this.enabled) {
        window.addEventListener('resize', this.onBodyResizeDebounced);
      }
    };
    this.componentDidUpdate = prevProps => {
      const {
        displayScales
      } = this.props;
      const {
        displayScales: prevDisplayScales
      } = prevProps;
      if (prevDisplayScales !== displayScales) {
        setDisplayScales(displayScales);
        if (this.enabled) {
          this.onBodyResize();
        }
      }
    };
    this.componentWillUnmount = () => {
      if (this.enabled) {
        window.removeEventListener('resize', this.onBodyResizeDebounced);
      }
    };
    setDisplayScales(props.displayScales);
    this.enabled = !!getProbeDivElement();
    if (this.enabled) {
      this.onBodyResize();
    }
  }
  render() {
    return null;
  }
}
export default /*#__PURE__*/memo(AutoFontResizer);